// extracted by mini-css-extract-plugin
export default {"tableWrapper":"HeiGrid_tableWrapper__4uOhv"};